import queryString from 'query-string';

function handleResponse(response) {
  let ok = response.status >= 200 && response.status < 300;
  let contentType = response.headers.get('Content-Type') || '';

  // json response
  if (contentType && contentType !== "" && contentType.includes('application/json')) {
    if (ok) {
      return response.json().then(r => {
          return r;
      }).catch(() => { return response; });
    }
    // error
    return response.json().then((body) => {
      return Promise.reject({
        status: response.status,
        body,
      });
    });
  }

  // not json response
  if (ok) {
    return response;
  }
  return Promise.reject({
    status: response.status,
    body: response.body
  });
}

// Request method to be exported

export const request = (base, options) => {
    const { method, headers, body } = options;

    // Request config
    const defaults = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
    };

    const config = Object.assign({}, defaults, options);

    // Request params
    let uri = `${base}`;
    if (options.path) {
        uri = `${base}/${options.path}`;
    }
    if (options.params) {
        uri = `${uri}?${queryString.stringify(options.params)}`;
    }

    return fetch(uri, config).then(handleResponse);
};

export const prefCentreService = {
    get: (user) => {
        let uri = `${process.env.RAZZLE_API_HOST}/1/account/profile/${user}`;
        let conf = {
            method: 'GET',
            headers: {
                'Content-Type': 'text/plain',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache, must-revalidate, private, max-age=0'
            }
        };
        return request(uri, conf);
    },
    patch: (data) => {
        let uri = `${process.env.RAZZLE_API_HOST}/1/account/profile/preferenceCentre`;
        let conf = {
            method: 'PATCH',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return request(uri, conf);
    }
}
